export default __webpack_public_path__ + "static/media/Deasil-Works-logo.0d968ce4.svg";